<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Messages</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">

          <div v-if="messages.length == 0" class="card">
            <div class="card-content">
              <div class="card-body">
                <p>There are currently no messages for you.</p>
              </div>
            </div>
          </div>

          <div v-if="messages.length > 0" class="card" v-for="message in messages" v-bind:key="message.id">
            <div class="card-header">
              <h4 class="card-title">{{message.copy}}</h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <p>Date: {{message.createdate}}</p>
                <p>{{message.title}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'messages',
  data: function () {
    return {
      messages: []
    }
  },
  mounted: function () {
    var that = this

    var data = {
      push_token: localStorage.getItem('push_token')
    }

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'basic/get_messages',
      type: 'post',
      data: data,
      success: function (data) {
        if (data.data.messages) {
          that.messages = data.data.messages
        }
      }
    })
  }
}
</script>
